import { createFileRoute, redirect } from "@tanstack/react-router";

/** /manage → /manage/members (the default Manage section). */
export const Route = createFileRoute("/manage/")({
  beforeLoad: () => {
    throw redirect({ to: "/manage/members" });
  },
});
